export const daysDepositList = [
  {
    'key': '/',
    'value': '/',
    'text': 'TODOS',
  },
  {
    'key': '0',
    'value': '0',
    'text': '< 30',
  },
  {
    'key': '1',
    'value': '1',
    'text': '30 - 60',
  },
  {
    'key': '2',
    'value': '2',
    'text': '61 - 90',
  },
  {
    'key': '3',
    'value': '3',
    'text': '91 - 120',
  },
  {
    'key': '4',
    'value': '4',
    'text': '> 120',
  },
];
